import { BaseMapper } from '@ps/utils';
import { BuyerSettingsDto } from '../dtos/buyer.dto';
import { BuyerSettings, VariableMapping } from '../../state/buyer-state.model';

export class BuyerSettingsMapper extends BaseMapper<
  BuyerSettingsDto,
  BuyerSettings
> {
  public override fromDto(dto: BuyerSettingsDto): BuyerSettings {
    return {
      cmp: dto.cmp,
      companyName: dto.companyName,
      isDecipher: dto.isDecipher,
      isHashing: dto.isHashing,
      isOutboundHash: dto.isOutboundHash,
      isDecipherHash: dto.is_decipher_hash,
      variableMapping: this._mapVariables(dto.variable_mapping),
      privateKey: dto.private_key,
      decipherPrivateKey: dto.decipher_private_key,
      hashType: dto.hashType?.toLowerCase() || null,
      consolidatedView: dto.consolidatedView,
      decipherHashKeyId: dto.decipherHashKeyID || null,
    };
  }

  private _mapVariables(
    variableMapping: Array<
      Record<string, { outgoing: string; incoming: string }>
    >,
  ): VariableMapping[] {
    return variableMapping.flatMap((entry) =>
      Object.entries(entry).map(([key, value]) => ({
        key,
        outgoing: value.outgoing,
        incoming: value.incoming,
      })),
    );
  }
}
